// import {ajaxPost, ajaxGet} from '@/common/js/ajax.js'
import { ajaxPost, ajaxGet } from '@/common/js/ajax.js'
export default {
  attendancePunchWayWebList: function (params, mask) {
    // 获取列表数据
    return ajaxGet('attendancePunchWay/findWebList', params, mask)
  },
  attendancePunchWayList: function (params, mask) {
    // 获取列表数据2
    return ajaxGet('attendancePunchWay/findList', params, mask)
  },
  attendancePunchWaySave: function (params, mask) {
    // 添加考勤方式
    return ajaxPost('attendancePunchWay/save', params, mask)
  },
  attendancePunchWayUpdate: function (params, mask) {
    // 修改考勤方式
    return ajaxPost('attendancePunchWay/update', params, mask)
  },
  attendancePunchWayDel: function (params, mask) {
    // 删除考勤方式
    return ajaxPost('attendancePunchWay/del', params, mask)
  },
  attendancePunchWayDetail: function (params, mask) {
    // 获取详情
    return ajaxPost('attendancePunchWay/findDetail', params, mask)
  },
  attenHolidayFindLeaveTypes: function (params, mask) {
    // 假期类型列表
    return ajaxPost('attendanceHoliday/findLeaveTypes', params, mask)
  },
  attenHolidaySaveLeaveType: function (params, mask) {
    // 保存假期类型
    return ajaxPost('attendanceHoliday/saveLeaveType', params, mask)
  },
  attenHolidayGetRemindSets: function (params, mask) {
    // 获取假期提醒设置
    return ajaxGet('attendanceHoliday/getSets', params, mask)
  },
  attenHolidaySaveRemindSet: function (params, mask) {
    // 保存假期提醒设置
    return ajaxPost('attendanceHoliday/saveSet', params, mask)
  },
  attenHolidaySaveLeaveGave: function (params, mask) {
    // 保存假期调整
    return ajaxPost('attendanceHoliday/saveLeaveGave', params, mask)
  },
  attenHolidaySaveLeaveGaves: function (params, mask) {
    // 批量编辑假期调整
    return ajaxPost('attendanceHoliday/saveLeaveGaves', params, mask)
  },
  attenHolidayFindLeaveGaves: function (params, mask) {
    // 假期调整列表
    return ajaxPost('attendanceHoliday/findLeaveGaves', params, mask)
  },
  attenHolidayFindLeaveAmounts: function (params, mask) {
    // 获取假期余额列表
    return ajaxPost('attendanceHoliday/findLeaveAmounts', params, mask)
  },
  attenHolidayGetLeaveAmount: function (params, mask) {
    // 获取个人假期余额
    return ajaxGet('attendanceHoliday/getLeaveAmount', params, mask)
  },
  attenHolidayGetLeaveDetail: function (params, mask) {
    // 个人假期余额详情
    return ajaxGet('attendanceHoliday/getLeaveDetail', params, mask)
  },
  attenHolidayUpdateHoliday: function (params, mask) {
    // 手动修改假期余额
    return ajaxPost('attendanceHoliday/updateHoliday', params, mask)
  },
  attenHolidayFindLogList: function (params, mask) {
    // 假期余额变动记录接口
    return ajaxGet('attendanceHoliday/findLogList', params, mask)
  },
  attenHolidayFindDetail: function (params, mask) {
    // 获取单个假期余额
    return ajaxGet('attendanceHoliday/findDetail', params, mask)
  },
  attenHolidayTemplateExport: function (params, mask) {
    // 获取考勤假期导入模板
    return ajaxGet('attendanceHoliday/attendanceHolidayTemplateExport', params, mask)
  },
  attenHolidayHolidayBalanceImport: function (params, mask) {
    // 导入假期
    return ajaxPost('attendanceHoliday/holidayBalanceImport', params, mask)
  },
  attenHolidayImportLeaveGave: function (params, mask) {
    // 导入批量发放假期
    return ajaxPost('attendanceHoliday/importLeaveGave', params, mask)
  },
  attenHolidayImportLeaveCut: function (params, mask) {
    // 导入批量扣减假期
    return ajaxPost('attendanceHoliday/importLeaveCut', params, mask)
  },
  attenHolidayExportLeaveGave: function (params, mask) {
    // 导出手动调整记录
    return ajaxPost('attendanceHoliday/exportLeaveGave', params, mask)
  },
  attenHolidayFindLeavers: function (params, mask) {
    // 假期一览列表
    return ajaxPost('attendanceHoliday/findLeavers', params, mask)
  },
  attenHolidayFindHolidayPlans: function (params, mask) {
    // 假期方案列表
    return ajaxPost('attendanceHoliday/findHolidayPlans', params, mask)
  },
  attenHolidaySaveHolidayPlan: function (params, mask) {
    // 保存假期方案
    return ajaxPost('attendanceHoliday/saveHolidayPlan', params, mask)
  },
  attendanceShiftList: function (params, mask) {
    // 班次管理-列表
    return ajaxPost('attendanceShift/findList', params, mask)
  },
  attendanceShiftSave: function (params, mask) {
    // 班次管理-保存
    return ajaxPost('attendanceShift/save', params, mask)
  },
  attendanceShiftUpdate: function (params, mask) {
    // 班次管理-保存
    return ajaxPost('attendanceShift/update', params, mask)
  },
  attendanceShiftDetail: function (params, mask) {
    // 班次管理-详情
    return ajaxGet('attendanceShift/findDetail', params, mask)
  },
  attendanceShiftDel: function (params, mask) {
    // 班次管理-删除
    return ajaxPost('attendanceShift/del', params, mask)
  },
  attendanceGroupNewList: function (params, mask) {
    // 考勤组-列表
    return ajaxGet('attendanceGroupNew/findWebList', params, mask)
  },
  attendanceGroupNewSave: function (params, mask) {
    // 考勤组-保存
    return ajaxPost('attendanceGroupNew/save', params, mask)
  },
  attendanceGroupNewUpdate: function (params, mask) {
    // 考勤组-修改
    return ajaxPost('attendanceGroupNew/update', params, mask)
  },
  attendanceGroupNewDetail: function (params, mask) {
    // 考勤组-详情
    return ajaxGet('attendanceGroupNew/findDetail', params, mask)
  },
  attendanceGroupNewDel: function (params, mask) {
    // 考勤组-删除
    return ajaxPost('attendanceGroupNew/del', params, mask)
  },
  attendanceGroupNewAutoMatch: function (params, mask) {
    // 考勤组-自动匹配班次
    return ajaxPost('attendanceGroupNew/setAutoMatch', params, mask)
  },
  checkEmployeeAttendanceGroup: function (params, mask) {
    // 考勤组-判断是否在同一考勤组
    return ajaxPost('attendanceGroupNew/checkEmployeeAttendanceGroup', params, mask)
  },
  attendanceScheduleCycleList: function (params, mask) {
    // 排班管理-周期列表
    return ajaxGet('attendanceScheduleCycle/queryList', params, mask)
  },
  attendanceScheduleCycleSave: function (params, mask) {
    // 排班管理-周期保存
    return ajaxPost('attendanceScheduleCycle/save', params, mask)
  },
  attendanceScheduleCycleUpdate: function (params, mask) {
    // 排班管理-周期修改
    return ajaxPost('attendanceScheduleCycle/update', params, mask)
  },
  attendanceScheduleCycleDel: function (params, mask) {
    // 排班管理-周期删除
    return ajaxPost('attendanceScheduleCycle/del', params, mask)
  },
  attendanceScheduleCycleApply: function (params, mask) {
    // 排班管理-排班周期
    return ajaxPost('attendanceScheduleCycle/apply', params, mask)
  },
  attendanceScheduleUpdate: function (params, mask) {
    // 排班管理-修改排班管理
    return ajaxPost('attendanceSchedule/update', params, mask)
  },
  attendanceScheduleList: function (params, mask) {
    // 排班管理-获取排班列表
    return ajaxGet('attendanceSchedule/findList', params, mask)
  },
  attendanceScheduleDetail: function (params, mask) {
    // 排班管理-修改排班管理
    return ajaxGet('attendanceSchedule/findDetail', params, mask)
  },
  attendanceScheduleExport: function (params, mask) {
    // 排班管理-导入排班记录模板
    return ajaxGet('attendanceSchedule/attendanceManagementDataExport', params, mask)
  },
  attendanceScheduleImport: function (params, mask) {
    // 排班管理-排班导入
    return ajaxGet('attendanceSchedule/attendanceManagementDataImport', params, mask)
  },
  attendanceScheduleByWeek: function (params, mask) {
    // 排班管理-周统计
    return ajaxPost('attendanceSchedule/statisticsByWeek', params, mask)
  },
  attendanceScheduleByDay: function (params, mask) {
    // 排班管理-日统计
    return ajaxPost('attendanceSchedule/statisticsByDay', params, mask)
  },
  attendancePatchCardRuleList: function (params, mask) {
    // 补卡规则-列表
    return ajaxGet('attendancePatchCardRule/findList', params, mask)
  },
  attendancePatchCardRuleSave: function (params, mask) {
    // 补卡规则-新增
    return ajaxPost('attendancePatchCardRule/save', params, mask)
  },
  attendancePatchCardRuleUpdate: function (params, mask) {
    // 补卡规则-编辑
    return ajaxPost('attendancePatchCardRule/update', params, mask)
  },
  attendancePatchCardRuledDel: function (params, mask) {
    // 补卡规则-删除
    return ajaxPost('attendancePatchCardRule/del', params, mask)
  },
  attendanceOutworkerRuleList: function (params, mask) {
    // 外出规则-列表
    return ajaxGet('attendanceOutworkerRule/findList', params, mask)
  },
  attendanceOutworkerRuleSave: function (params, mask) {
    // 外出规则-新增
    return ajaxPost('attendanceOutworkerRule/save', params, mask)
  },
  attendanceOutworkerRuleUpdate: function (params, mask) {
    // 外出规则-编辑
    return ajaxPost('attendanceOutworkerRule/update', params, mask)
  },
  attendanceOutworkerRuleDel: function (params, mask) {
    // 外出规则-删除
    return ajaxPost('attendanceOutworkerRule/del', params, mask)
  },
  attendanceOnBusinessRuleList: function (params, mask) {
    // 出差规则-列表
    return ajaxGet('attendanceOnBusinessRule/findList', params, mask)
  },
  attendanceOnBusinessRuleSave: function (params, mask) {
    // 出差规则-新增
    return ajaxPost('attendanceOnBusinessRule/save', params, mask)
  },
  attendanceOnBusinessRuleUpdate: function (params, mask) {
    // 出差规则-编辑
    return ajaxPost('attendanceOnBusinessRule/update', params, mask)
  },
  attendanceOnBusinessRuleDel: function (params, mask) {
    // 出差规则-删除
    return ajaxPost('attendanceOnBusinessRule/del', params, mask)
  },
  attendanceOvertimeRuleList: function (params, mask) {
    // 加班规则-列表
    return ajaxGet('attendanceOvertimeRule/findList', params, mask)
  },
  attendanceOvertimeRuleSave: function (params, mask) {
    // 加班规则-新增
    return ajaxPost('attendanceOvertimeRule/save', params, mask)
  },
  attendanceOvertimeRuleUpdate: function (params, mask) {
    // 加班规则-编辑
    return ajaxPost('attendanceOvertimeRule/update', params, mask)
  },
  attendanceOvertimeRuleDetail: function (params, mask) {
    // 加班规则-详情
    return ajaxGet('attendanceOvertimeRule/findDetail', params, mask)
  },
  attendanceOvertimeRuledDel: function (params, mask) {
    // 加班规则-删除
    return ajaxPost('attendanceOvertimeRule/del', params, mask)
  },
  attenHolidayExportLeavers: function (params, mask) {
    // 导出休假列表
    return ajaxPost('attendanceHoliday/exportLeavers', params, mask)
  },
  attendanceCycleQueryList: function (params, mask) {
    // 查询考勤周期设置列表
    return ajaxGet('attendanceCycleSetting/queryList', params, mask)
  },
  attendanceCycleDel: function (params, mask) {
    // 删除考勤周期设置
    return ajaxPost('attendanceCycleSetting/del', params, mask)
  },
  attendanceCycleUpdateEnabled: function (params, mask) {
    // 开启（关闭）考勤周期设置
    return ajaxPost('attendanceCycleSetting/updateEnabled', params, mask)
  },
  attendanceCycleUpdate: function (params, mask) {
    // 编辑考勤周期设置
    return ajaxPost('attendanceCycleSetting/update', params, mask)
  },
  attendanceCycleSave: function (params, mask) {
    // 新增考勤周期设置
    return ajaxPost('attendanceCycleSetting/save', params, mask)
  },
  attendanceHolidayImportLeave: function (params, mask) {
    // 导入历史假期余额
    return ajaxPost('attendanceHoliday/importLeave', params, mask)
  },
  attenHolidayExportLeaveGaveUpdate: function (params, mask) {
    // 导出余额变动记录
    return ajaxPost('attendanceHoliday/exportLeaveGaveUpdate', params, mask)
  },
  attenHolidayExportLeaveGaveSum: function (params, mask) {
    // 导出假期余额
    return ajaxPost('attendanceHoliday/exportLeaveGaveSum', params, mask)
  },
  attendancePunchCardList: function (params, mask) {
    // 打卡记录-列表
    return ajaxPost('attendancePunchCard/queryList', params, mask)
  },
  attendancePunchCardSave: function (params, mask) {
    // 打卡记录-新增
    return ajaxPost('attendancePunchCard/addRecord', params, mask)
  },
  attendancePunchCardUpdate: function (params, mask) {
    // 打卡记录-编辑
    return ajaxPost('attendancePunchCard/updateRecord', params, mask)
  },
  attendancePunchCardDel: function (params, mask) {
    // 打卡记录-删除
    return ajaxPost('attendancePunchCard/delRecord', params, mask)
  },
  attendancePunchCardExport: function (params, mask) {
    // 打卡记录-模板下载
    return ajaxGet('attendancePunchCard/punchCardDataTemplateExport', params, mask)
  },
  attendancePunchCardImport: function (params, mask) {
    // 打卡记录-记录导入
    return ajaxPost('attendancePunchCard/punchCardDataImport', params, mask)
  },
  attendancePunchCardDataExport: function (params, mask) {
    // 打卡记录-记录导入
    return ajaxPost('attendancePunchCard/punchCardDataExport', params, mask)
  },
  attendanceApplyLeaveList: function (params, mask) {
    // 请假记录-列表
    return ajaxPost('attendanceApplyLeave/queryList', params, mask)
  },
  attendanceApplyLeaveDetail: function (params, mask) {
    // 请假记录-详情
    return ajaxGet('attendanceApplyLeave/queryDetail', params, mask)
  },
  attendanceApplyLeaveSave: function (params, mask) {
    // 请假记录-新增
    return ajaxPost('attendanceApplyLeave/save', params, mask)
  },
  attendanceApplyLeaveUpdate: function (params, mask) {
    // 请假记录-编辑
    return ajaxPost('attendanceApplyLeave/update', params, mask)
  },
  attendanceApplyLeaveDel: function (params, mask) {
    // 请假记录-删除
    return ajaxPost('attendanceApplyLeave/del', params, mask)
  },
  attendanceApplyLeaveDataImport: function (params, mask) {
    // 请假记录-请假记录导入
    return ajaxPost('attendanceApplyLeave/applyLeaveDataImport', params, mask)
  },
  attendanceApplyLeaveBatchSave: function (params, mask) {
    // 请假记录-批量修改
    return ajaxPost('attendanceApplyLeave/batchSave', params, mask)
  },
  attendancePatchCardList: function (params, mask) {
    // 补卡记录-列表
    return ajaxPost('attendancePatchCard/queryList', params, mask)
  },
  attendancePatchCardSave: function (params, mask) {
    // 补卡记录-新增
    return ajaxPost('attendancePatchCard/save', params, mask)
  },
  attendancePatchCardUpdate: function (params, mask) {
    // 补卡记录-编辑
    return ajaxPost('attendancePatchCard/update', params, mask)
  },
  attendancePatchCardDel: function (params, mask) {
    // 补卡记录-删除
    return ajaxPost('attendancePatchCard/del', params, mask)
  },
  attendancePatchCardDataImport: function (params, mask) {
    // 补卡记录-补卡记录导入
    return ajaxPost('attendancePatchCard/patchCardDataImport', params, mask)
  },
  attendancePatchCardBatchSave: function (params, mask) {
    // 补卡记录-批量修改
    return ajaxPost('attendancePatchCard/batchSave', params, mask)
  },
  attendanceOutworkerList: function (params, mask) {
    // 外出/出差记录-列表
    return ajaxPost('attendanceOutworker/queryList', params, mask)
  },
  attendanceOutworkerSave: function (params, mask) {
    // 外出/出差记录-新增
    return ajaxPost('attendanceOutworker/save', params, mask)
  },
  attendanceOutworkerUpdate: function (params, mask) {
    // 外出/出差记录-编辑
    return ajaxPost('attendanceOutworker/update', params, mask)
  },
  attendanceOutworkerDel: function (params, mask) {
    // 外出/出差记录-删除
    return ajaxPost('attendanceOutworker/del', params, mask)
  },
  attendanceOutworkerDataImport: function (params, mask) {
    // 外出/出差记录-外出/出差记录导入
    return ajaxPost('attendanceOutworker/outworkerDataImport', params, mask)
  },
  attendanceOutworkerQueryRule: function (params, mask) {
    // 外出/出差记录-查询外出/出差规则
    return ajaxPost('attendanceOutworker/queryRule', params, mask)
  },
  attendanceOutworkerCaclTime: function (params, mask) {
    // 外出/出差记录-计算外出/出差时间
    return ajaxPost('attendanceOutworker/caclTime', params, mask)
  },
  attendanceOutworkerBatchSave: function (params, mask) {
    // 外出/出差记录-批量修改
    return ajaxPost('attendanceOutworker/batchSave', params, mask)
  },
  attendanceOvertimeList: function (params, mask) {
    // 加班记录-列表
    return ajaxPost('attendanceOvertime/queryList', params, mask)
  },
  attendanceOvertimeSave: function (params, mask) {
    // 加班记录-新增
    return ajaxPost('attendanceOvertime/save', params, mask)
  },
  attendanceOvertimeUpdate: function (params, mask) {
    // 加班记录-编辑
    return ajaxPost('attendanceOvertime/update', params, mask)
  },
  attendanceOvertimeDel: function (params, mask) {
    // 加班记录-删除
    return ajaxPost('attendanceOvertime/del', params, mask)
  },
  attendanceOvertimeDataImport: function (params, mask) {
    // 加班记录-导入
    return ajaxPost('attendanceOvertime/overtimeDataImport', params, mask)
  },
  attendanceOvertimeBatchSave: function (params, mask) {
    // 加班记录-批量修改
    return ajaxPost('attendanceOvertime/batchSave', params, mask)
  },
  attendanceOvertimeQueryRule: function (params, mask) {
    // 加班记录-获取加班规则
    return ajaxPost('attendanceOvertime/queryRule', params, mask)
  },
  attenDownloadTem: function (params, mask) {
    // 下载导入模版
    return ajaxGet('common/file/templateDownload', params, mask)
  },
  attenApprovalSaveAttendanceSetting: function (params, mask) {
    // 保存设置
    return ajaxPost('layoutTemplate/saveAttendanceSetting', params, mask)
  },
  attenApprovalGetAttendanceSetting: function (params, mask) {
    // 获取设置
    return ajaxGet('layoutTemplate/getAttendanceSetting', params, mask)
  },
  attenApprovalsaveAttendanceData: function (params, mask) {
    // 保存审批数据
    return ajaxPost('layoutTemplate/saveAttendanceData', params, mask)
  },
  findEmployeeeAttendanceGroup: function (params, mask) {
    // 查人员考勤组
    return ajaxGet('attendanceGroupNew/findEmployeeeAttendanceGroup', params, mask)
  },
  findEmployeeShift: function (params, mask) {
    // 根据时间获取班次
    return ajaxPost('attendanceSchedule/findEmployeeShift', params, mask)
  },
  attenAppfindBeanDatas: function (params, mask) {
    // 获取关联数据
    return ajaxPost('layoutTemplate/findBeanDatas', params, mask)
  },
  attenSaveSetting: function (params, mask) {
    // 保存考勤设置
    return ajaxPost('attendanceGlobalSetting/saveSetting', params, mask)
  },
  attenSaveRemind: function (params, mask) {
    // 保存考勤提醒
    return ajaxPost('attendanceGlobalSetting/saveRemind', params, mask)
  },
  attenSaveTopList: function (params, mask) {
    // 保存榜单设置
    return ajaxPost('attendanceGlobalSetting/saveTopList', params, mask)
  },
  attenSaveDingding: function (params, mask) {
    // 保存钉钉对接配置
    return ajaxPost('attendanceGlobalSetting/saveDingding', params, mask)
  },
  attenSaveCorpid: function (params, mask) {
    // 保存企业微信对接配置
    return ajaxPost('attendanceGlobalSetting/saveCorpid', params, mask)
  },
  attenTurnSwitch: function (params, mask) {
    // 开启或关闭考勤机
    return ajaxPost('attendanceGlobalSetting/turnSwitch', params, mask)
  },
  attenFindAllSetting: function (params, mask) {
    // 查询考勤设置
    return ajaxGet('attendanceGlobalSetting/findAllSetting', params, mask)
  },
  attendanceDailySummaryList: function (params, mask) {
    // 每日考勤-列表
    return ajaxPost('attendanceDailySummary/queryList', params, mask)
  },
  attendanceDailySummaryDataExport: function (params, mask) {
    // 每日考勤-导出
    return ajaxPost('attendanceDailySummary/dailyDataExport', params, mask)
  },
  queryMonthlyDataList: function (params, mask) {
    // 月考勤汇总列表
    return ajaxPost('attendanceDailySummary/queryMonthlyDataList', params, mask)
  },
  queryMonthlyDataView: function (params, mask) {
    // 月考勤明细列表
    return ajaxPost('attendanceDailySummary/queryMonthlyDataView', params, mask)
  },
  monthDataExportNew: function (params, mask) {
    // 月考统计列表导出
    return ajaxPost('attendanceDailySummary/monthDataExportNew', params, mask)
  },
  queryMonthlyDataCount: function (params, mask) {
    // 查询月考勤头部统计
    return ajaxPost('attendanceDailySummary/queryMonthlyDataCount', params, mask)
  },
  attendanceDailySummaryUnlock: function (params, mask) {
    // 月考勤汇总解锁
    return ajaxPost('attendanceDailySummary/unlock', params, mask)
  },
  attendanceDailySummaryLock: function (params, mask) {
    // 月考勤汇总锁定
    return ajaxPost('attendanceDailySummary/lock', params, mask)
  },
  attendanceDailySummaryLockStatus: function (params, mask) {
    // 查询锁定状态
    return ajaxGet('attendanceDailySummary/lockStatus', params, mask)
  },
  attendanceReportSettingList: function (params, mask) {
    // 报表设置-列表
    return ajaxPost('attendanceReportSetting/findList', params, mask)
  },
  attendanceReportSettingUpdate: function (params, mask) {
    // 报表设置-更新
    return ajaxPost('attendanceReportSetting/update', params, mask)
  },
  attendanceReportSettingDel: function (params, mask) {
    // 报表设置-删除
    return ajaxPost('attendanceReportSetting/del', params, mask)
  },
  saveWorkHoursConvertRule: function (params, mask) {
    // 保存时间折算
    return ajaxPost('attendanceGlobalSetting/saveWorkHoursConvertRule', params, mask)
  },
  shiftChangeRecordSave: function (params, mask) {
    // 调班记录-新增
    return ajaxPost('shiftChangeRecord/save', params, mask)
  },
  shiftChangeRecordUpdate: function (params, mask) {
    // 调班记录-编辑
    return ajaxPost('shiftChangeRecord/update', params, mask)
  },
  shiftChangeRecordDel: function (params, mask) {
    // 调班记录-删除
    return ajaxPost('shiftChangeRecord/del', params, mask)
  },
  shiftChangeRecordDataImport: function (params, mask) {
    // 调班记录-导入
    return ajaxPost('shiftChangeRecord/dataImport', params, mask)
  },
  shiftChangeRecordDataExport: function (params, mask) {
    // 调班记录-导出
    return ajaxPost('shiftChangeRecord/dataExport', params, mask)
  },
  shiftChangeRecordList: function (params, mask) {
    // 调班记录-列表
    return ajaxPost('shiftChangeRecord/findList', params, mask)
  },
  attendanceDailySummaryUpdate: function (params, mask) {
    // 更新考勤状态
    return ajaxPost('attendanceDailySummary/update', params, mask)
  },
  attendanceOvertimeCaclTime: function (params, mask) {
    // 获取加班时长
    return ajaxPost('attendanceOvertime/caclTime', params, mask)
  },
  attendanceApplyLeaveCaclTime: function (params, mask) {
    // 获取请假时长
    return ajaxPost('attendanceApplyLeave/caclTime', params, mask)
  },
  downloadMonthlyDataTemplate: function (params, mask) {
    // 月考勤汇总导入模板下载
    return ajaxPost('attendanceDailySummary/downloadMonthlyDataTemplate', params, mask)
  },
  monthlyDataImport: function (params, mask) {
    // 月考勤汇总导入
    return ajaxPost('attendanceDailySummary/monthlyDataImport', params, mask)
  },
  launchAttendanceConfirm: function (params, mask) {
    // 月报发送确认
    return ajaxGet('attendanceConfirm/launchAttendanceConfirm', params, mask)
  },
  saveHalfDayRule: function (params, mask) {
    // 保存弄半天配置
    return ajaxPost('attendanceGlobalSetting/saveHalfDayRule', params, mask)
  },
  getLeaveBalanceGroupByYear: function (params, mask) {
    // 余额列表按年统计
    return ajaxGet('attendanceHoliday/getLeaveBalanceGroupByYear', params, mask)
  },
  getLeaveUsedListGroupByYear: function (params, mask) {
    // 使用记录
    return ajaxGet('attendanceHoliday/getLeaveUsedListGroupByYear', params, mask)
  },
  getLeaveBalanceList: function (params, mask) {
    // 变更记录
    return ajaxGet('attendanceHoliday/getLeaveBalanceList', params, mask)
  },
  saveMapConfig: function (params, mask) {
    // 保存地图配置
    return ajaxPost('attendanceHoliday/saveSetAppKey', params, mask)
  },
  getMapConfig: function (params, mask) {
    // 获取地图配置
    return ajaxGet('attendanceHoliday/getSetAppKeys', params, mask)
  }
}
